import { render, staticRenderFns } from "./WebShopCategoryList.vue?vue&type=template&id=006aae0d&scoped=true&"
import script from "./WebShopCategoryList.vue?vue&type=script&lang=js&"
export * from "./WebShopCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./WebShopCategoryList.vue?vue&type=style&index=0&id=006aae0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006aae0d",
  null
  
)

export default component.exports